import { defineMessages } from 'react-intl';

export default defineMessages({
  noCategories: {
    id: 'sku-category-dropdown.no-categories',
    defaultMessage: 'No categories available. Add a category to get started.',
  },
  noResults: {
    id: 'sku-category-dropdown.no-results',
    defaultMessage: 'No categories found.',
  },
  searchPlaceholder: {
    id: 'sku-category-dropdown.search-placeholder',
    defaultMessage: 'Search categories',
  },
  removeCategory: {
    id: 'sku-category-dropdown.remove-category',
    defaultMessage: 'Remove',
  },
  removeCategoryAriaLabel: {
    id: 'sku-category-dropdown.remove-category-aria-label',
    defaultMessage: 'Remove {categoryName} from {menuName}',
  },
});
